const jwt = require('jsonwebtoken');

function decodeToken() {
  try {
    const token = sessionStorage.mstoken ? sessionStorage.mstoken : localStorage.token;
    return jwt.decode(token);
  } catch (e) {
    return null;
  }
}

const hasAccessRoleInToken = (requiredRoles) => {
  const decodedToken = decodeToken();
  if (!decodedToken) return false;
  // Example structure of decodedToken: { authorities: ["BI.GeneralAccess", "MultipleCustomers"] }
  const authorities = decodedToken.authorities || [];
  return requiredRoles.some((role) => authorities.includes(role));
};

const features = {
  quickLinks: () => hasAccessRoleInToken(['MultipleCustomers', 'SingleCustomer']),
  quickAddReading: () => hasAccessRoleInToken(['MultipleCustomers', 'SingleCustomer']),
};

export default features;
